import { TZDate } from "@date-fns/tz";
import { isPast } from "date-fns";
import { ComposeMessageEditorErrorType } from "domains/message-component/reducer.types";

import { ValidateMessageProps } from "./validateMessage";

export const validateScheduledTime = ({
    sendAtDateTime,
}: Pick<
    ValidateMessageProps,
    "sendAtDateTime"
>): ComposeMessageEditorErrorType => {
    return sendAtDateTime && isPast(new TZDate(sendAtDateTime, "Europe/London"))
        ? { scheduledTime: "SCHEDULED_TIME_HAS_PASSED" }
        : {};
};
